import React from "react"
export const AuthContext = React.createContext({})

export function AuthProvider(props) {

    var token = "MokgguH7YUDCDVmwZfl5njztdQacH3ptdFv4i8MonxorjK/1vLwDr0tYd4t/GTgujqJY9PG5QrHiEuxMgm9JsQ=="

    return (
        <AuthContext.Provider value={{ token }} >

            {props.children}

        </AuthContext.Provider>
    )

}